import { HttpClient } from "../../api/HttpClient"
import { cn } from "../../lib/utils"
import { fetchCategories } from "../category/services/category"
import MediaUpload from "../media/pages/AddNewMedia"
import Media from "../media/pages/Media"
import { fetchPostByCategories } from "../post/services/post"
import ButtonMA from "../ui-builder/config/assets/button-ma.svg"
import ButtonManuScroll from "../ui-builder/config/assets/button-manuscroll.svg"
import DefaultImage from "../ui-builder/config/assets/empty-img.jpg"
import iconSubmit from "../ui-builder/config/assets/Group.svg"
import IconArrowLeft from "../ui-builder/config/assets/icon-arrow-left.svg"
import IconArrowRight from "../ui-builder/config/assets/icon-arrow-right.svg"
import iconFacebook from "../ui-builder/config/assets/icon-facebook.svg"
import iconTiktok from "../ui-builder/config/assets/icon-tiktok.svg"
import iconYoutube from "../ui-builder/config/assets/icon-youtube.svg"
import iconMail from "../ui-builder/config/assets/iconGmail.svg"
import iconHotline from "../ui-builder/config/assets/iconHotline.svg"
import iconZalo from "../ui-builder/config/assets/iconZalo.svg"
import ButtonPlay from "../ui-builder/config/assets/play-button.svg"
import IconSearch from "../ui-builder/config/assets/search-icon.svg"
import iconSearchFooter from "../ui-builder/config/assets/vector-input.svg"
import iconLocation from "../ui-builder/config/assets/vectorLocation.svg"
import { useUiBuilder } from "./services/ui-builder"

export const configs = {
  API_URL: import.meta.env.VITE_API_URL,
  DOMAIN: import.meta.env.VITE_DOMAIN_SKE,
}

export const filterOption = (input: string, option?: { label: string; value: string }) =>
  normalizeText((option?.label ?? "").toLowerCase()).includes(normalizeText(input.toLowerCase()))

export const normalizeText = (text: string) => {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
}
export const getSettings = async () => {
  const response = await HttpClient.get<{ data: any }>(`settings?populate=*&sort=id:DESC`)
  return response.data
}

export {
  ButtonMA,
  ButtonManuScroll,
  ButtonPlay,
  cn,
  DefaultImage,
  fetchCategories,
  fetchPostByCategories,
  IconArrowLeft,
  IconArrowRight,
  iconFacebook,
  iconHotline,
  iconLocation,
  iconMail,
  IconSearch,
  iconSearchFooter,
  iconSubmit,
  iconTiktok,
  iconYoutube,
  iconZalo,
  Media,
  MediaUpload,
  useUiBuilder,
}
